export * from './table';

//# sourceMappingURL=index.js.map